<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav" />
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
          <b-modal id="app-refresh-modal" hide-footer>
            <template #modal-title>
              Update Available
            </template>
            <div class="d-block text-center">
              <h4>New dashboard update available. Click the button below to refresh the page.</h4>
            </div>
            <b-button class="mt-3" block @click="refreshPage()">Refresh Page</b-button>
          </b-modal>
        </div>
      </main>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '@/lib/nav'
import { Header as AppHeader, Sidebar, Footer as AppFooter, Breadcrumb } from '../components/'
import { refreshPageMixin } from '../components/mixins/refresh-page'
import { getUser } from '@/lib/auth'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
      nav: this.parseNavItems(this.filterNavItemsByRole(nav.items))
    }
  },
  mixins: [refreshPageMixin],
  watch: {
    hashChanged: function (val) {
      if (val && process.env.NODE_ENV != "development") this.$bvModal.show('app-refresh-modal')
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  },
  beforeCreate () {
    document.body.classList.remove('photo-bg')
  },
  methods: {
    filterNavItemsByRole (navItems) {
      const user = getUser()
      const userRole = user ? user.role : null
      
      return navItems.filter(item => {
        // If item has requiresRole property, check if user has that role
        if (item.requiresRole) {
          return userRole === item.requiresRole
        }
        
        // If item has children, filter children by role
        if (item.children) {
          item.children = item.children.filter(child => {
            if (child.requiresRole) {
              return userRole === child.requiresRole
            }
            return true
          })
        }
        
        return true
      })
    },
    parseNavItems (navItems) {
      navItems.forEach((navItem) => {
        if (Object.keys(navItem).includes('children')) {
          navItem.children.forEach((child) => {
            if (child.url === this.$route.path) {
              navItem.expanded = true
            }
          })
        }
      })
      return navItems
    },
    refreshPage() {
      this.$bvModal.hide('app-refresh-modal')
      this.reloadApp()
    }
  }
}
</script>
